import { useCallback } from 'react';
import useAxios, { api } from '@hooks/useFetch';
import { components, paths } from '@api/api';

const CUSTOM_RESTAURANT_LISTS_ENDPOINT: keyof paths = '/CustomRestaurantLists';
type CustomRestaurantListViewModel = components['schemas']['MenuTrends.Application.Contracts.Models.Restaurants.CustomRestaurantList.CustomRestaurantListViewModel'];
type CustomRestaurantListDetailsViewModel = components['schemas']['MenuTrends.Application.Contracts.Models.Restaurants.CustomRestaurantList.CustomRestaurantListDetailsViewModel'];
type CustomRestaurantListsResponse = CustomRestaurantListViewModel[];

export default function useCustomRestaurantLists(countryCode: string = 'USA') {
    const {
        data,
        isLoading,
        error,
        doFetch,
    } = useAxios<CustomRestaurantListsResponse>({
        method: 'get',
        url: `${CUSTOM_RESTAURANT_LISTS_ENDPOINT}/${countryCode}`,
        lazy: false,
    });

    const createList = useCallback(
        async (listData: CustomRestaurantListDetailsViewModel) => {
            await api.request({
                url: CUSTOM_RESTAURANT_LISTS_ENDPOINT,
                method: 'post',
                data: listData,
            });
            await doFetch();
        },
        [doFetch]
    );

    const updateList = useCallback(
        async (listData: CustomRestaurantListDetailsViewModel) => {
            await api.request({
                url: CUSTOM_RESTAURANT_LISTS_ENDPOINT,
                method: 'put',
                data: listData,
            });
            await doFetch();
        },
        [doFetch]
    );

    const deleteList = useCallback(
        async (countryCode: string, id: number) => {
            await api.request({
                url: `${CUSTOM_RESTAURANT_LISTS_ENDPOINT}/${countryCode}/${id}`,
                method: 'delete',
            });
            await doFetch();
        },
        [doFetch]
    );

    return {
        data,
        isLoading,
        error,
        doFetch,
        createList,
        updateList,
        deleteList,
    };
}
